import fonts from 'styles/typography.module.css';
import { Dialog, DialogContent } from '@mui/material';
import { ModalHeader } from 'layouts/Generic/modal-header';
import * as React from 'react';
import { Error } from './stages';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export const ErrorModal: React.FC<Props> = (props) => {
  const { open, onClose, ...rest } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: 'w-[960px] max-w-[80%]' }}
      className={fonts.font}
    >
      <ModalHeader onClose={onClose}>
        <p className="font-bold">Could not download screenshot</p>
      </ModalHeader>
      <DialogContent className="p-8" dividers>
        <Error onClose={onClose} {...rest} />
      </DialogContent>
    </Dialog>
  );
};
ErrorModal.displayName = 'ErrorModal';
